/**
 * Determines cache strategy based on request context
 * @param {Object} options - Fetch options
 * @param {string} defaultCache - Default cache strategy
 * @returns {string} - Appropriate cache strategy
 */
const getCacheStrategy = (options = {}, defaultCache = 'force-cache') => {
  const { headers = {} } = options;

  // Check if user is actually authenticated (has auth token)
  const hasAuthToken = headers.authorization || headers.Authorization;

  // If user is authenticated, don't cache (user-specific data)
  if (hasAuthToken) {
    return 'no-store';
  }

  // For anonymous requests, we can cache safely
  // Apollo Client uses 'include' but without auth token, it's safe to cache
  return defaultCache;
};

export default getCacheStrategy;
